import { render, staticRenderFns } from "./SSOSitesCard.vue?vue&type=template&id=62169680&scoped=true"
import script from "./SSOSitesCard.vue?vue&type=script&lang=js"
export * from "./SSOSitesCard.vue?vue&type=script&lang=js"
import style0 from "./SSOSitesCard.vue?vue&type=style&index=0&id=62169680&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62169680",
  null
  
)

export default component.exports